import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { Grid, Button, Dropdown } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { ChevronLeftIcon, CaretsVerticalIcon, ChevronRightIcon } from '@enterprise-ui/icons';
import React, { useRef, useState, useEffect } from 'react';
import { checkYearInRange, getYearOfDate, shouldMonthNavDisable, getMonthNameOfDate, getMonthOfDate } from '../../utility.js';
import { MONTHS, todayYear } from '../utils/gregorianUtility.js';

function RawNavHeader(_ref) {
  var activeMonth = _ref.activeMonth,
    selectMonth = _ref.selectMonth,
    yearRange = _ref.yearRange;
  var selectedYearMenuItemRef = useRef(null);
  var _useState = useState({
      next: false,
      prev: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isMonthNavDisabled = _useState2[0],
    setIsMonthNavDisabled = _useState2[1];
  function rangeDropdown() {
    var range = yearRange.endYear - yearRange.startYear;
    return Array(yearRange.endYear - yearRange.startYear + 1).fill().map(function (m, i) {
      var isSelectedYear = getYearOfDate(activeMonth) === yearRange.endYear + i - range;
      return /*#__PURE__*/React.createElement(Dropdown.MenuItem, {
        ref: isSelectedYear ? selectedYearMenuItemRef : null,
        key: yearRange.endYear + i - range,
        selected: isSelectedYear,
        className: yearRange.endYear + i - range === todayYear ? 'isToday' : '',
        onClick: function onClick() {
          selectMonth('year', yearRange.endYear + i - range);
        }
      }, yearRange.endYear + i - range);
    });
  }
  useEffect(function () {
    if (selectMonth) {
      selectMonth('year', checkYearInRange(yearRange, getYearOfDate(activeMonth)));
    }
  }, [yearRange]);
  useEffect(function () {
    // don't run this logic unless there is a year range restriction
    if (yearRange) {
      var monthNavDisableValues = shouldMonthNavDisable(yearRange, activeMonth, isMonthNavDisabled);
      if (monthNavDisableValues) {
        setIsMonthNavDisabled(monthNavDisableValues);
      }
    }
  }, [yearRange, activeMonth]);
  return /*#__PURE__*/React.createElement(Grid.Container, {
    align: "center",
    spacing: "none"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Button, {
    "data-test": "popUpPrev",
    disabled: isMonthNavDisabled.prev,
    "aria-label": "previous month",
    className: "C-DatePicker__NavButton",
    onClick: function onClick() {
      return selectMonth('prev');
    },
    size: 'dense',
    iconOnly: true
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: ChevronLeftIcon
  }))), /*#__PURE__*/React.createElement(Grid.Item, {
    xs: true,
    className: "hc-ta-center",
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    align: "center",
    justify: "center",
    spacing: "none"
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    className: "C-DatePicker__Dropdown__MonthSelect",
    size: "dense"
  }, /*#__PURE__*/React.createElement("span", {
    className: "C-DatePicker__Dropdown__Parent"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "C-DatePicker__Dropdown__Button"
  }, getMonthNameOfDate(activeMonth)), /*#__PURE__*/React.createElement(EnterpriseIcon, {
    className: "C-DatePicker__Dropdown__Icon",
    icon: CaretsVerticalIcon
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, MONTHS.map(function (month, i) {
    return /*#__PURE__*/React.createElement(Dropdown.MenuItem, {
      key: i,
      selected: getMonthOfDate(activeMonth) === i,
      onClick: function onClick() {
        selectMonth('month', i);
      }
    }, month);
  })))), /*#__PURE__*/React.createElement(Grid.Item, {
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    className: "C-DatePicker__Dropdown__YearSelect",
    size: "dense",
    onRequestOpen: function onRequestOpen() {
      if ((selectedYearMenuItemRef === null || selectedYearMenuItemRef === void 0 ? void 0 : selectedYearMenuItemRef.current) !== null) {
        selectedYearMenuItemRef.current.focus();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "C-DatePicker__Dropdown__Parent"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "C-DatePicker__Dropdown__Button"
  }, checkYearInRange(yearRange, getYearOfDate(activeMonth))), /*#__PURE__*/React.createElement(EnterpriseIcon, {
    className: "C-DatePicker__Dropdown__Icon",
    icon: CaretsVerticalIcon
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, yearRange ? rangeDropdown() : Array.apply(0, Array(120)).map(function (_, i) {
    var isSelectedYear = getYearOfDate(activeMonth) === todayYear + i - 60;
    return /*#__PURE__*/React.createElement(Dropdown.MenuItem, {
      ref: isSelectedYear ? selectedYearMenuItemRef : null,
      key: todayYear + i - 60,
      selected: isSelectedYear,
      className: todayYear === todayYear + i - 60 ? 'isToday' : '',
      onClick: function onClick() {
        selectMonth('year', todayYear + i - 60);
      }
    }, todayYear + i - 60);
  })))))), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Button, {
    "data-test": "popUpNext",
    disabled: isMonthNavDisabled.next,
    "aria-label": "next month",
    className: "C-DatePicker__NavButton",
    onClick: function onClick() {
      return selectMonth('next');
    },
    size: 'dense',
    iconOnly: true
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: ChevronRightIcon
  }))));
}
RawNavHeader.displayName = 'NavHeader';
var NavHeader = /*#__PURE__*/React.memo(RawNavHeader);

export { NavHeader as default };
